/**
 * Szám stringgé alakítása. Ha a számunk kisebb, 10, akkor kap egy 0 előtagot.
 * @param   {number} num - A számunk.
 * @returns {string}     Számunk stringként.
 */
module.exports.pad = function pad (num) {
  return (num < 10) ? `0${ num }` : `${ num }`
}
